import React from 'react'
import { Avatar } from 'antd'
import { UserOutlined, LogoutOutlined, BellOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Badge } from 'antd'
import { useHistory } from 'react-router-dom'
import './styles/style.less'
import basic from '../constants/basic'
import { logout } from '../redux/actions'
import { useDispatch } from 'react-redux'
import { useTranslation } from "react-i18next"

const user_data = localStorage.getItem("user-data")
const userData = user_data ? JSON.parse(user_data) : {}

function RightContent() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const Logout = function () {
    localStorage.removeItem('token')
    localStorage.removeItem("user-data")
    dispatch(logout())
    localStorage.clear()
    history.push('/login')
    document.location.reload()
  }

  return (
    <div className="sidebar-user-info">
      <div className="sidebar-user-content">
        <div className="sidebar-user-details">
          <Avatar
            size={36}
            className='sidebar-avatar'
            src={userData.image ?? basic.USER_LOGO}
            icon={<UserOutlined />}
          />
          <div className="sidebar-user-text">
            <h3 className='sidebar-user-name'>{userData.name}</h3>
            <p className='sidebar-user-role'>{userData.role ?? 'Administrator'}</p>
          </div>
        </div>
        <button 
          onClick={() => {
            Logout()
          }}
          className="sidebar-logout-btn"
          title={t('logout')}
        >
          <svg className="logout-icon" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M4 18h2v2h12V4H6v2H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3zm2-7h7v2H6v3l-5-4 5-4v3z"></path>
          </svg>
        </button>
      </div>
    </div>
  )
}

export default RightContent
